var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-image-input"},[_c('el-input',{attrs:{"placeholder":"请输入网络路径","value":_vm.url},on:{"input":_vm.handleInput}}),(_vm.url !== '')?_c('img',{attrs:{"src":_vm.url}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }